import { action } from 'easy-peasy';
import {
  IPaginationResponse,
  IPublicationResponseBody,
  IIssueTokens,
  IProjectMilestone,
  IProjectEvent,
  ICommunityDetailsResponseBody,
  ICommunitiesListResponseBody,
} from 'types';
import { ICommunityActions, ICommunityState } from 'types/store/community';
import { CommunityStatus } from 'constants/community';
import { ICommunityStatement } from 'types/api/community-statement';

export const actions: ICommunityActions = {
  setCommunitiesList: action<ICommunityState, IPaginationResponse<ICommunitiesListResponseBody>>((state, payload) => {
    state.communitiesList = payload;
  }),
  setTopCommunitiesList: action<ICommunityState, IPaginationResponse<ICommunityDetailsResponseBody>>(
    (state, payload) => {
      state.topCommunitiesList = payload;
    },
  ),
  setTopEmissionReductionsCommunitiesList: action<ICommunityState, IPaginationResponse<ICommunitiesListResponseBody>>(
    (state, payload) => {
      state.topEmissionReductionsCommunitiesList = payload;
    },
  ),
  setNewCommunitiesList: action<ICommunityState, IPaginationResponse<ICommunitiesListResponseBody>>(
    (state, payload) => {
      state.newCommunitiesList = payload;
    },
  ),
  setCommunityById: action<ICommunityState, ICommunityDetailsResponseBody>((state, payload) => {
    state.communityById = payload;
  }),
  setFavoriteCommunityById: action<ICommunityState, boolean>((state, payload) => {
    if (state.communityById) {
      state.communityById.isFavorite = payload;
    }
  }),
  setCommunity: action<ICommunityState, ICommunityDetailsResponseBody>((state, payload) => {
    state.community = payload;
  }),
  setCommunityStatus: action<ICommunityState, CommunityStatus>((state, payload) => {
    if (state.community?.status) {
      state.community.status = payload;
    }
  }),
  setCommunityLoading: action<ICommunityState, boolean>((state, payload) => {
    state.isCommunityLoading = payload;
  }),
  setCommunityIssueTokensRequest: action<ICommunityState, IIssueTokens>((state, payload) => {
    if (state.community?.issueTokensRequest === null) {
      state.community.issueTokensRequest = payload;
    }
  }),

  //STATEMENTS
  setCommunityStatements: action<ICommunityState, IPaginationResponse<ICommunityStatement>>((state, payload) => {
    state.communityStatements = payload;
  }),

  //PUBLICATIONS
  setCommunityPublications: action<ICommunityState, IPaginationResponse<IPublicationResponseBody>>((state, payload) => {
    state.communityPublications = payload;
  }),

  //MILESTONES
  setCommunityMilestones: action<ICommunityState, IPaginationResponse<IProjectMilestone>>((state, payload) => {
    state.communityMilestones = payload;
  }),

  //EVENTS
  setCommunityEvents: action<ICommunityState, IPaginationResponse<IProjectEvent>>((state, payload) => {
    state.communityEvents = payload;
  }),

  // FAVORITES
  setFavoriteCommunitiesList: action<ICommunityState, IPaginationResponse<ICommunitiesListResponseBody>>(
    (state, payload) => {
      state.favoriteCommunitiesList = payload;
    },
  ),
};
